exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\n.square-curriculum-wrap .vux-slider > .vux-indicator > a {\n  margin-left: 0.18rem;\n}\n.square-curriculum-wrap .vux-slider > .vux-indicator {\n  line-height: 1px;\n}\n.square-curriculum-wrap .vux-slider > .vux-indicator > a > .vux-icon-dot {\n  height: 6px;\n  width: 6px;\n  border-radius: 50%;\n  background-color: #ffffff;\n}\n.square-curriculum-wrap .vux-slider > .vux-indicator > a > .vux-icon-dot.active {\n  width: 12px;\n  border-radius: 20px;\n  background-color: #32b16c;\n}\n", ""]);

// exports
